import React from 'react'
import { useQuery } from '@apollo/client'

import { ContentLoaderTableOnly } from '../../../components/loader/loader.component'
import TableComponent from '../../../components/table/table.component'
import LabelComponent from '../../../components/label/label.component'
import LinkComponent from '../../../components/link/link.component'

import { ActionContainer, SortingContainer } from '../admin.styles'

import { GET_ACTIVITY_LIST } from '../../../config/graphql'

const ActivityList = ({ dateRange, groupFilter }) => {
    console.log({ variables: {...dateRange, ...groupFilter} })
    const { loading, data } = useQuery(GET_ACTIVITY_LIST, { variables: {...dateRange, ...groupFilter} });
    console.log(data);
    const dataActivity = data?.activities || [];
    console.log(dataActivity);

    if (loading && !dataActivity.length) {
      return <ContentLoaderTableOnly />
    } else {
      var idx = 0;
      return <div>
        <TableComponent mode='custom' template='1fr 3fr 3fr 4fr'>
          <div aria-label='head'>
            <div>
              <SortingContainer>No</SortingContainer>
            </div>
            <div>
              <SortingContainer>Tanggal</SortingContainer>
            </div>
            <div>
              <SortingContainer>Nama Admin</SortingContainer>
            </div>
            <div>
              <SortingContainer>Jumlah</SortingContainer>
            </div>
          </div>
          <div aria-label='body'>
            {dataActivity.map((activity) => {
                idx++;
                return (
                  <div key={idx}>
                    <div>
                      <LabelComponent mode='tagredmobile'>NO</LabelComponent>
                      {idx}
                    </div>
                    <div>
                      <LabelComponent mode='tagredmobile'>Tanggal</LabelComponent>
                      {(new Date(Date.parse(activity.createdAt))).toLocaleDateString('id', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} - {(new Date(Date.parse(activity.createdAt))).toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' })}
                    </div>
                    <div>
                      <LabelComponent mode='tagredmobile'>Nama Admin</LabelComponent>
                      {(activity.admin.name)}
                    </div>
                    <div>
                      <LabelComponent mode='tagredmobile'>Action</LabelComponent>
                      {(activity.action)}
                    </div>
                  </div>
                )
            })}
          </div> 
        </TableComponent>
      </div>
    }
}

export default ActivityList;